export const brandStrings = {
  nameStart: 'Hob',
  nameEnd: 'talk',
  kicker: 'Hobby life, organized',
};

export const commonStrings = {
  actions: {
    close: 'Close',
    loadMore: 'Load more',
    open: 'Open',
    signIn: 'Sign in',
    signOut: 'Sign out',
    skip: 'Skip',
  },
  auth: {
    signInAgain: 'Please sign in again.',
    authenticating: 'Hobtalk is authenticating...',
    opening: 'Opening Hobtalk...',
    accessPending: {
      eyebrow: 'Private beta',
      title: 'Access is not enabled for this account yet.',
      detail: 'Hobtalk is currently limited to approved users while the app is under development.',
      signedInAs: (email) => ` You are signed in as ${email}.`,
      emailUnavailable: ' We could not read an email address.',
    },
    sessionExpired: {
      eyebrow: 'Session expired',
      title: 'Please sign in again to continue.',
      detail: 'Your browser session has expired. After signing in, we will bring you back to this page.',
    },
  },
  counts: {
    hobbies: (count) => `${count} ${count === 1 ? 'hobby' : 'hobbies'}`,
    ideas: (count) => `${count} ${count === 1 ? 'idea' : 'ideas'}`,
    modules: (count) => `${count} ${count === 1 ? 'module' : 'modules'}`,
    recommendations: (count) => `${count} ${count === 1 ? 'recommendation' : 'recommendations'}`,
  },
  loading: {
    activity: 'Loading activity...',
    generic: 'Loading',
    profile: 'Loading profile',
  },
  priority: {
    low: 'Low',
  },
};
